import { useMutation } from '@tanstack/react-query'

import { updateSamlConfiguration } from '@src/api'
import { DefaultApiUpdateSamlConfigurationRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateSamlConfiguration = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiUpdateSamlConfigurationRequest) =>
      updateSamlConfiguration(axiosInstance, params),
  })
}
